<template>
  <div>
    <div class="sidebar" data="blue">
      <div class="sidebar-wrapper">
        <ul class="nav">
          <li v-for="(item, index) in menuLinks" :key="index">
            <router-link
              v-if="item.visible"
              :to="{name: item.link}"
              :class="{'active': $route.path.indexOf(item.link) > -1}"
              :dusk="'nav_to_'+item.link"
              :id="item.link+'-guide'"
              @click.native="closeSideNav"
            >
              <span v-html="item.text"></span>
            </router-link>
          </li>
          <li v-if="this.user && this.user.role == 'investor'">
            <a href="https://www.capsphere.com.my/investor-faq" target="_blank" rel="noopener noreferrer">
              <span>
                <i class="fa fa-question"></i> &nbsp;&nbsp;FAQ
              </span>
            </a>
          </li>
          <!-- <li>
            <a href="#" @click.prevent="logout" dusk="button_logout">
              <span>
                <i class="tim-icons icon-button-power"></i> Log out
              </span>
            </a>
          </li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { api, siteName } from "../../config";
import jwtToken from "../../helpers/jwt-token";
import eventUuid from "../../helpers/event-uuid";

export default {
  name: "SideNav",

  props: {
    menuLinks: Array,
  },
  data() {
    return {
      user: null,
      siteName: siteName,
    };
  },

  mounted() {
      this.user = this.$store.state.auth;
  },

  methods: {
    logout() {
      axios
        .post(api.logout, { eventUuid: eventUuid.getEventUuid() })
        .then((res) => {
          if (res.data.success) {
            // unset user auth
            this.$store
              .dispatch("unsetAuthUser")
              .then(() => {
                // go to login page
                jwtToken.removeToken();
                eventUuid.removeEventUuid();
                this.$noty.success("You are logged out");
                this.$router.push({ name: "login" });
              })
              .catch((err) => {
                // error in unsetting authenticated user
              });
          } else {
            this.$noty.error(
              "Something went wrong, unable to logout, try refreshing."
            );
          }
        })
        .catch((err) => {
          this.$noty.error("Something went wrong, unable to logout");
        });
    },
    closeSideNav() {
      this.$nextTick(() => {
        if ($('[id="sideMenuToggler"]')[0].parentElement.getAttribute('class').includes('toggled') == true) {
          $('[id="sideMenuToggler"]').click()
        }
      })
    }
  },
};
</script>

<style scoped>
</style>
